import React from 'react'
import PropTypes from 'prop-types'
import PageValue from './PageValue'
import OrderValue from './OrderValue'
import CustomSelect from './CustomSelect'
import './index.css'
import textTemplate from '../../common/textTemplate'
import texts from '../../common/texts.json'

const showPropductPerPage = (page, hitsPerPage, productsDisplayed, productsFound, TEXT) => {
  const from = ((page - 1) * hitsPerPage) + 1
  const last = ((page - 1) * hitsPerPage) + productsDisplayed
  return textTemplate(TEXT, { from, last, total: productsFound })
}

const ProductsQuantityAndOrderDesktop = ({
  productsFound,
  hitsPerPage,
  optionsHitPerPage,
  setHitsPerPage,
  optionsSortBy,
  sortByHandler,
  sortByDefault,
  page,
  productsDisplayed,
}) => (
  <div className="products-qantity-and-order-desktop shop-content">
    <div className="products-qantity-and-order-desktop__quantity-shown">
      {showPropductPerPage(page, hitsPerPage, productsDisplayed, productsFound, texts.PAGINATION.RESUME)}
    </div>
    <div className="products-qantity-and-order-desktop__selectors-container">
      <CustomSelect
        formatOptionLabel={({ value }, { context }) => {
          if (context === 'value') {
            return <PageValue hitsPerPage={value} />
          }
          return value
        }}
        placeholder={<PageValue hitsPerPage={hitsPerPage} />}
        setSelectedValue={setHitsPerPage}
        options={optionsHitPerPage}
        selected={hitsPerPage}
      />
      <CustomSelect
        formatOptionLabel={({ label }, { context }) => {
          if (context === 'value') {
            return <OrderValue orderType={label} />
          }
          return label
        }}
        placeholder={<OrderValue orderType={optionsSortBy.find(item => item.value === sortByDefault).label} />}
        setSelectedValue={sortByHandler}
        options={optionsSortBy}
        selected={sortByDefault}
      />
    </div>
  </div>
)

ProductsQuantityAndOrderDesktop.propTypes = {
  hitsPerPage: PropTypes.number.isRequired,
  productsFound: PropTypes.number.isRequired,
  setHitsPerPage: PropTypes.func.isRequired,
  sortByHandler: PropTypes.func.isRequired,
  optionsHitPerPage: PropTypes.array.isRequired,
  optionsSortBy: PropTypes.array.isRequired,
  sortByDefault: PropTypes.string.isRequired,
  page: PropTypes.number.isRequired,
  productsDisplayed: PropTypes.number.isRequired,
}


export default ProductsQuantityAndOrderDesktop
